import { SessionSummaryContent } from './types'

export const aiSummaryMock: SessionSummaryContent = {
    segments: [
        {
            index: 0,
            name: 'Attempted login with repeated technical failures',
            start_event_id: 'aa96510c',
            end_event_id: 'aa22bba9',
            meta: {
                duration: 12,
                duration_percentage: 0.2222,
                events_count: 22,
                events_percentage: 0.2418,
                key_action_count: 3,
                failure_count: 3,
                abandonment_count: 1,
                confusion_count: 2,
                exception_count: 2,
            },
        },
        {
            index: 1,
            name: 'Completed sign-up and account creation',
            start_event_id: '664cfed9',
            end_event_id: '3e3d5ba1',
            meta: {
                duration: 16,
                duration_percentage: 0.2963,
                events_count: 16,
                events_percentage: 0.1758,
                key_action_count: 2,
                failure_count: 0,
                abandonment_count: 0,
                confusion_count: 0,
                exception_count: 0,
            },
        },
        {
            index: 2,
            name: 'Onboarded, explored product, and accessed settings',
            start_event_id: 'a80ea631',
            end_event_id: 'a229de03',
            meta: {
                duration: 21,
                duration_percentage: 0.3889,
                events_count: 55,
                events_percentage: 0.6044,
                key_action_count: 3,
                failure_count: 1,
                abandonment_count: 0,
                confusion_count: 0,
                exception_count: 1,
            },
        },
    ],
    key_actions: [
        {
            segment_index: 0,
            events: [
                {
                    description: 'Login attempt failed due to missing Team ID (blocking error)',
                    abandonment: false,
                    confusion: false,
                    exception: 'blocking',
                    event_id: '4dca0e8f',
                    timestamp: '2025-04-28T18:14:28.922000+00:00',
                    milliseconds_since_start: 0,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/login?next=/',
                    event: 'query failed',
                    event_type: null,
                    event_index: 2,
                    event_uuid: '00000000-0000-0000-0001-000000000001',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
                {
                    description: 'Multiple login attempts failed due to repeated client/server errors',
                    abandonment: false,
                    confusion: true,
                    exception: 'blocking',
                    event_id: 'c2662174',
                    timestamp: '2025-04-28T18:14:37.830000+00:00',
                    milliseconds_since_start: 8886,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/login?next=/',
                    event: 'client_request_failure',
                    event_type: null,
                    event_index: 15,
                    event_uuid: '00000000-0000-0000-0001-000000000002',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
                {
                    description: 'User abandoned login flow after repeated failures and switched to sign-up',
                    abandonment: true,
                    confusion: true,
                    exception: null,
                    event_id: 'aa22bba9',
                    timestamp: '2025-04-28T18:14:41.149000+00:00',
                    milliseconds_since_start: 12205,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/login?next=/',
                    event: 'client_request_failure',
                    event_type: null,
                    event_index: 21,
                    event_uuid: '00000000-0000-0000-0001-000000000003',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
            ],
        },
        {
            segment_index: 1,
            events: [
                {
                    description: 'User initiated sign-up flow after login failures',
                    abandonment: false,
                    confusion: false,
                    exception: null,
                    event_id: '664cfed9',
                    timestamp: '2025-04-28T18:14:43.050000+00:00',
                    milliseconds_since_start: 14106,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/login?next=/',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 22,
                    event_uuid: '00000000-0000-0000-0001-000000000004',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
                {
                    description: 'Completed multi-step sign-up and account creation',
                    abandonment: false,
                    confusion: false,
                    exception: null,
                    event_id: '3e3d5ba1',
                    timestamp: '2025-04-28T18:14:59.829000+00:00',
                    milliseconds_since_start: 30885,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/signup',
                    event: '$autocapture',
                    event_type: 'submit',
                    event_index: 37,
                    event_uuid: '00000000-0000-0000-0001-000000000005',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
            ],
        },
        {
            segment_index: 2,
            events: [
                {
                    description: 'Completed onboarding and product setup',
                    abandonment: false,
                    confusion: false,
                    exception: null,
                    event_id: '547e15ce',
                    timestamp: '2025-04-28T18:15:13.973000+00:00',
                    milliseconds_since_start: 45029,
                    window_id: null,
                    current_url: 'http://localhost:8010/project/2/onboarding/session_replay?step=invite_teammates',
                    event: 'product onboarding completed',
                    event_type: null,
                    event_index: 74,
                    event_uuid: '00000000-0000-0000-0001-000000000006',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
                {
                    description: 'Non-blocking error in replay home, user continued without interruption',
                    abandonment: false,
                    confusion: false,
                    exception: 'non-blocking',
                    event_id: '608eeb2e',
                    timestamp: '2025-04-28T18:15:14.506000+00:00',
                    milliseconds_since_start: 45562,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/project/2/replay/home',
                    event: '$exception',
                    event_type: null,
                    event_index: 82,
                    event_uuid: '00000000-0000-0000-0001-000000000007',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
                {
                    description: 'Navigated to project settings and explored options',
                    abandonment: false,
                    confusion: false,
                    exception: null,
                    event_id: 'e9268043',
                    timestamp: '2025-04-28T18:15:17.767000+00:00',
                    milliseconds_since_start: 48823,
                    window_id: '01967d9b-8f1c-7002-9d3a-462d4912fdaa',
                    current_url: 'http://localhost:8010/project/2/replay/home',
                    event: '$autocapture',
                    event_type: 'click',
                    event_index: 87,
                    event_uuid: '00000000-0000-0000-0001-000000000008',
                    session_id: '00000000-0000-0000-0001-000000000000',
                },
            ],
        },
    ],
    segment_outcomes: [
        {
            segment_index: 0,
            summary: 'User failed to log in due to repeated technical errors and abandoned the login flow.',
            success: false,
        },
        {
            segment_index: 1,
            summary: 'User successfully completed the sign-up process and created a new account.',
            success: true,
        },
        {
            segment_index: 2,
            summary:
                'User completed onboarding, explored product features, and accessed settings despite a minor error.',
            success: true,
        },
    ],
    session_outcome: {
        description:
            'Despite initial login failures, user completed sign-up, onboarding, and explored product features and settings. Technical errors blocked login but did not prevent overall conversion.',
        success: true,
    },
}
